<mat-card appearance="outlined" class="table-container" content>
  <div class="table-header">
    <span *ngIf="historyDataSource.totalItemsText$ | async as totalItemsText">
      {{ totalItemsText }}
    </span>
  </div>
  <mat-table matSort [dataSource]="historyDataSource" multiTemplateDataRows>
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef class="title-column" [ngClass]="{ small: (isBulkActionsV2Enabled$ | async) }">
        Action
      </mat-header-cell>
      <mat-cell *matCellDef="let history" class="title-column" [ngClass]="{ small: (isBulkActionsV2Enabled$ | async) }">
        <div class="title" [attr.title]="history.itemId">
          {{ history.title }}
        </div>
        <div class="description" *ngIf="history.description">
          {{ history.description }}
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="number-of-accounts">
      <mat-header-cell *matHeaderCellDef class="number-of-accounts-column">
        <ng-container *ngIf="isBulkActionsV2Enabled$ | async; else legacyTitle">Errors</ng-container>
        <ng-template #legacyTitle>Number of Accounts</ng-template>
      </mat-header-cell>
      <mat-cell *matCellDef="let history" class="number-of-accounts-column">
        <ng-container *ngIf="isBulkActionsV2Enabled$ | async; else legacy">
          <app-errors
            [itemData]="history"
            [isErrorShowing]="history?.itemId === expandedItemId"
            (toggleErrors)="toggleInlineErrors($event)"
          ></app-errors>
        </ng-container>
        <ng-template #legacy>
          <app-number-of-accounts
            [history]="history"
            [isErrorShowing]="history?.itemId === expandedItemId"
            (retryImport)="retryListImport($event)"
            (toggleErrors)="toggleInlineErrors($event)"
          ></app-number-of-accounts>
        </ng-template>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef class="status-column">
        Status
        <span matTooltip="This feature is currently under development">(Alpha)</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let history" class="status-column">
        <app-status-column [historyItemId]="history.itemId" [workType]="history.type"></app-status-column>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="performed-by">
      <mat-header-cell *matHeaderCellDef class="performed-by-column">Performed By</mat-header-cell>
      <mat-cell *matCellDef="let history" class="performed-by-column">
        <div *ngIf="!history.impersonated">{{ history.performedBy }}</div>
        <div *ngIf="history.impersonated">Administrator</div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="performed-date">
      <mat-header-cell
        *matHeaderCellDef
        class="performed-date-column-header"
        matTooltip="{{ 'LISTS.ACCOUNT_LIST.HISTORY.YOUR_LOCAL_TIME' | translate : { timezone: timezone } }}"
      >
        Time
      </mat-header-cell>
      <mat-cell
        *matCellDef="let history"
        class="performed-date-column"
        matTooltip="{{ 'LISTS.ACCOUNT_LIST.HISTORY.YOUR_LOCAL_TIME' | translate : { timezone: timezone } }}"
      >
        <div>{{ history.performedDate | glxyDate }}</div>
        <div>{{ history.performedDate | glxyDate : DateFormat.shortTime }}</div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-column"></mat-header-cell>
      <mat-cell *matCellDef="let history" class="actions-column">
        <app-actions-menu
          [historyItemId]="history?.itemId"
          [itemData]="history"
          [isErrorShowing]="history?.itemId === expandedItemId"
          (errorsToggled)="toggleInlineErrors($event)"
        ></app-actions-menu>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="errorDetails">
      <mat-cell *matCellDef="let history" [attr.colspan]="(displayedColumns$ | async)?.length">
        <div
          class="error-details"
          *ngIf="history.errors"
          [@errorExpand]="history.itemId === expandedItemId ? 'expanded' : 'collapsed'"
        >
          <mat-list>
            <mat-list-item *ngFor="let error of history.errors">
              <mat-icon matListIcon class="error-icon">error</mat-icon>
              <div matLine>
                <span class="error-reason">{{ error.reason }}</span>
                <span class="error-action">
                  <button mat-button color="primary" (click)="openAddErrorAccountsToList(history, error)">
                    Create List for {{ error.numberOfAccounts }} Accounts
                  </button>
                </span>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns$ | async"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns$ | async" matRipple class="history-row"></mat-row>
    <mat-row *matRowDef="let row; columns: ['errorDetails']" class="error-details-row"></mat-row>
  </mat-table>
  <div class="table-footer">
    <mat-spinner *ngIf="loading$ | async; else loadMoreButton" [diameter]="30"></mat-spinner>
    <ng-template #loadMoreButton>
      <app-empty-table-placeholder
        *ngIf="(historyDataSource.history$ | async)?.length === 0"
        [message]="'No action has been performed on this list yet.'"
        [showButton]="false"
      ></app-empty-table-placeholder>
      <button mat-button class="load-more-button" color="primary" *ngIf="hasMore$ | async" (click)="loadNextPage()">
        Load More
      </button>
    </ng-template>
  </div>
</mat-card>
<iframe id="download-frame" style="display: none"></iframe>
